<template>
  <div class="map-container">
    <mgl-map :access-token="mapConfig.accessToken"
             :map-style="mapConfig.style"
             :center="center"
             :zoom="mapConfig.initialZoom"
             :attribution-control="true"
             class="map"
             @load="onMapLoad"
             @click="removeActiveCoordinate"
    >
     <map-marker
      v-for="(coordinate, index) in filteredCoordinates"
      :key="index"
      :coordinate="coordinate"
      is-in-map
      @marker-click="onMarkerClick"
    />

    </mgl-map>
  </div>
</template>

<script>
import Mapbox from 'mapbox-gl';
import { MglMap } from 'vue-mapbox';
import MapMarker from "@/components/common/TheMap/MapMarker.vue";
import { mapState, mapGetters, mapActions } from 'vuex';
import mapbox from "@/config/mapbox";
import getMapboxRouteLayer from "@/helpers/getMapboxRouteLayer";
import appBreakpoints from "@/config/appBreakpoints";

let map = {
  fitBoundsCall: null,
  flyToCall: null,
  addLayerCall: null,

  fitBounds(...options) {
    this.fitBoundsCall = options
  },
  flyTo(...options) {
    this.flyToCall = options
  },
  addLayer(...options) {
    this.addLayerCall = options
  },
  getSource() {
    return null;
  },
  getZoom() {
    return mapbox.initialZoom;
  }
}

export default {
  name: "TheMap",
  components: {
    MglMap,
    MapMarker
  },
  data() {
    return {
      mapbox: null,
      isMapLoaded: false,
      hasActivatedRouteFromQuery: false,
      mapConfig: {
        accessToken: mapbox.accessToken,
        style: mapbox.style,
        initialZoom: mapbox.initialZoom
      },
      center: {
        lng: mapbox.center.lng,
        lat: mapbox.center.lat
      },
      fitSquare: [
        [0, 0],
        [0, 0]
      ]
    }
  },
  computed: {
    ...mapState('Filters', ['searchQuery']),
    ...mapState('Coordinates', {
      'storeActiveCoordinateId': 'activeCoordinateId'
    }),
    ...mapGetters('Routes', ['activeRoute']),
    ...mapGetters('Coordinates', ['getCoordinateById']),
    ...mapGetters('Coordinates', ['coordinates']),
     validUniqueCoordinates() {
      const map = new Map()
      this.coordinates.forEach(c => {
        if (c && c.id && !map.has(c.id)) {
          map.set(c.id, c)
        }
      })
      return [...map.values()]
    },
    coordinatesIds() {
      return this.coordinates
        .map(({ id }) => id)
        .sort()
    },
    activeCoordinateId: {
      get() {
        return this.storeActiveCoordinateId
      },
      set(coordinateId) {
        this.setStoreActiveCoordinateId(coordinateId)
      }
    },
    filteredCoordinates() {
      const query = this.searchQuery?.toLowerCase().trim();
      if (!query) return this.coordinates;

      return this.coordinates.filter(coord =>
        coord.images?.some(img => {
          const company = (img.company || '').toLowerCase();
          const description = (img.description || '').toLowerCase();
          return company.includes(query) || description.includes(query);
        })
      );
    },
    centerMode() {
      return this.$route.name === 'home' || this.$bp.isLgOrLess
    }
  },
  // mounted() {
  //   this.$root.$on('map.fitMap', () => {
  //     this.fitMap()
  //   })
  // },
 mounted() {
  this.$root.$on('map.fitMap', () => {
    this.fitMap()
  })

  // const routeId = Number(this.$route.query.routeId)
  const rawRouteId = this.$route.query.routeId
const routeId = rawRouteId ? Number(rawRouteId) : null
  if (routeId) {
    this.activateRouteFromQuery(routeId)
  }
}
,
  created() {
    this.mapbox = Mapbox
  },
  
  methods: {
    tryDrawActiveRoute() {
    const route = this.activeRoute
    if (!route) return

    // coordinates abhi ready nahi
    if (route.coordinates.length < 2) {
      return
    }

    this.mountMapRoute(route)
      .then(() => {
        this.fitMap(route.coordinates, true)
      })
  },
     activateRouteFromQuery(routeId) {
  if (this.hasActivatedRouteFromQuery) return

  const route = this.$store.getters['Routes/getRouteById'](routeId)
  if (!route) return

  this.hasActivatedRouteFromQuery = true
  this.$store.dispatch('Routes/setActiveRouteId', routeId)
  this.$store.dispatch('Interface/setRoutesListOpenState', true)
}
,
    getFitConfig(withMaxZoom = false) {
      const timelineOffset = window.innerWidth > appBreakpoints.xl
        ? 370
        : window.innerWidth > appBreakpoints.lg
        ? 250
        : 40
      const sidebarGalleryOffset = window.innerWidth > appBreakpoints.xl
        ? 410
        : window.innerWidth > appBreakpoints.lg
        ? 250
        : 40
      const routeDetailsOffset = window.innerWidth > appBreakpoints.md ? 400 : 0
      const routesListOffset = 430

      const hasActiveRoute = this.activeRoute !== null

      const top = window.innerWidth > appBreakpoints.lg ? 150 : 80
      const bottom = hasActiveRoute ? routesListOffset : 160
      const right = this.centerMode
        ? timelineOffset + (hasActiveRoute ? routeDetailsOffset : 0)
        : window.innerWidth - sidebarGalleryOffset
      const left = this.centerMode
        ? sidebarGalleryOffset
        : 40

      return {
        padding: {
          top,
          bottom,
          right,
          left
        },
        maxZoom: withMaxZoom ? mapbox.initialZoom : 25.5 // 25.5 is max value for maxZoom property
      }
    },
    onMapLoad(event) {
      let fitBoundsCall = map.fitBoundsCall
      let flyToCall = map.flyToCall
      let addLayerCall = map.addLayerCall

      map = event.map

      if (flyToCall) {
        map.flyTo(...flyToCall)
      } else if (fitBoundsCall) {
        map.fitBounds(...fitBoundsCall)
      } else {
        this.fitMap(undefined, true)
      }

      if (addLayerCall) {
        map.addLayer(...addLayerCall)
      }

      this.isMapLoaded = true
       if (this.activeRoute && this.activeRoute.coordinates.length > 1) {
    this.mountMapRoute(this.activeRoute)
      .then(() => {
        this.fitMap(this.activeRoute.coordinates, true)
      })
  }
    },
    async mountMapRoute(route) {
      const geometry = await route.getGeometry()

      if (geometry) {
        this.drawMapRoute(geometry)
      }
    },
    drawMapRoute(geometry) {
      this.clearMapRoute()

      map.addLayer(getMapboxRouteLayer(geometry));
    },
    clearMapRoute() {
      if (map.getSource('route')) {
        map.removeLayer('route');
        map.removeSource('route');
      }
    },
    recalculateCenter(coordinates = this.coordinates) {
      if (coordinates.length === 0) {
        this.center.lng = mapbox.center.lng
        this.center.lat = mapbox.center.lat

        const FIT_SQUARE_RADIUS = 0.03

        this.fitSquare[0][0] = mapbox.center.lng - FIT_SQUARE_RADIUS
        this.fitSquare[0][1] = mapbox.center.lat - FIT_SQUARE_RADIUS
        this.fitSquare[1][0] = mapbox.center.lng + FIT_SQUARE_RADIUS
        this.fitSquare[1][1] = mapbox.center.lat + FIT_SQUARE_RADIUS

        return;
      }

      let lngMin = coordinates[0].lng,
        latMin = coordinates[0].lat,
        lngMax = coordinates[0].lng,
        latMax = coordinates[0].lat;

      coordinates.forEach(({ lng, lat }) => {
        lngMin = Math.min(lngMin, lng)
        latMin = Math.min(latMin, lat)
        lngMax = Math.max(lngMax, lng)
        latMax = Math.max(latMax, lat)
      })

      this.fitSquare[0][0] = lngMin
      this.fitSquare[0][1] = latMin
      this.fitSquare[1][0] = lngMax
      this.fitSquare[1][1] = latMax
    },
    fitMap(coordinates = this.coordinates, forceRecalculate = false) {
      if (!map) {
        return;
      }
      if (this.fitSquare.flat().every((c) => c === 0) || forceRecalculate) {
        this.recalculateCenter(coordinates)
      }
      map.fitBounds(this.fitSquare, this.getFitConfig(coordinates.length === 1))
    },
    zoomToCoordinate(coordinate = this.getCoordinateById(this.activeCoordinateId)) {
      if (!map) {
        return;
      }
      if (this.centerMode) {
        const currentZoom = map.getZoom();
        map.flyTo({
          center: [coordinate.lng, coordinate.lat],
          zoom:
            currentZoom < this.mapConfig.initialZoom ? this.mapConfig.initialZoom : currentZoom,
          speed: .8
        })
      } else {
        // postpone fitting on the next tick for initial fit to active coordinate
        setTimeout(() => {
          map.fitBounds([
            [coordinate.lng, coordinate.lat],
            [coordinate.lng, coordinate.lat]
          ], this.getFitConfig(true))
        })
      }
    },
    onMarkerClick(coordinate) {
      if (this.activeCoordinateId === coordinate.id) {
         this.$router.push({ name: 'itemGallery', params: { itemId: coordinate.id }, query: { ...this.$route.query } })
      } else {
        this.removeActiveCoordinate()
        this.setActiveCoordinate(coordinate)

        if (this.$route.name === 'itemGallery') {
           this.$router.push({ name: 'itemGallery', params: { itemId: coordinate.id }, query: { ...this.$route.query } })
        }
      }
    },
    setActiveCoordinate(coordinate) {
      this.activeCoordinateId = coordinate.id
    },
    removeActiveCoordinate() {
      this.activeCoordinateId = null
    },

    ...mapActions('Coordinates', {
      'setStoreActiveCoordinateId': 'setActiveCoordinateId'
    })
  },
 watch: {
  // 🔹 1. URL query param watcher (MAIN FIX)
  '$route.query.routeId': {
    immediate: true,
    handler(routeId) {

      if (!routeId) return

      const parsedRouteId = Number(routeId)
      if (Number.isNaN(parsedRouteId)) {
        return
      }

      this.activateRouteFromQuery(parsedRouteId)
    }
  },

  // 🔹 2. Routes async load safety
  '$store.state.Routes.routes'(routes) {
    const routeId = this.$route.query.routeId
    if (!routeId || !routes.length) return

    const parsedRouteId = Number(routeId)
    if (Number.isNaN(parsedRouteId)) return

    this.activateRouteFromQuery(parsedRouteId)
  },

  // 🔹 3. Coordinates change → refit map
  coordinatesIds(newIds, oldIds) {
    if (newIds.join() !== oldIds.join()) {
      this.fitMap(undefined, true)
    }

    if (!~newIds.indexOf(this.activeCoordinateId)) {
        this.removeActiveCoordinate()
      }
  },

  // 🔹 4. Active coordinate zoom
  activeCoordinateId(coordinateId) {
    if (coordinateId === null) {
      this.fitMap()
    } else {
      this.zoomToCoordinate(this.getCoordinateById(coordinateId))
    }
  },

  // 🔹 5. Responsive center handling
  centerMode() {
    if (this.activeCoordinateId !== null) {
      this.zoomToCoordinate()
    } else {
      this.fitMap()
    }
  },

  // 🔹 6. Active route → draw / clear route
  // activeRoute: {
  //   deep: true,
  //   handler(activeRoute) {
  //     console.log('[ACTIVE ROUTE WATCH]', activeRoute)

  //     if (activeRoute && activeRoute.coordinates.length > 1) {
  //       this.mountMapRoute(activeRoute)
  //         .then(() => {
  //           if (!activeRoute.isEditing) {
  //             this.fitMap(activeRoute.coordinates, true)
  //           }
  //         })
  //     } else if (this.isMapLoaded) {
  //       this.clearMapRoute()
  //       this.fitMap(undefined, true)
  //     }
  //   }
  // }
//   activeRoute: {
//   deep: true,
//   handler(activeRoute) {
//     if (!this.isMapLoaded) {
//       console.log('[ROUTE WAIT] Map not loaded yet')
//       return
//     }

//     if (activeRoute && activeRoute.coordinates.length > 1) {
//       this.mountMapRoute(activeRoute)
//         .then(() => {
//           if (!activeRoute.isEditing) {
//             this.fitMap(activeRoute.coordinates, true)
//           }
//         })
//     } else {
//       this.clearMapRoute()
//       this.fitMap(undefined, true)
//     }
//   }
// }
//  activeRoute: {
//     deep: true,
//     handler(route) {
//       if (!route || !this.isMapLoaded) return
//       this.tryDrawActiveRoute()
//     }
//   },
// activeRoute(route) {
//   if (!route) return  

//   const currentRouteId = this.$route.query.routeId

//   if (String(route.id) !== currentRouteId) {
//     this.$router.replace({
//       query: { routeId: route.id }
//     })
//   }
// },
activeRoute: {
  deep: true,
  handler(route) {
    if (!this.isMapLoaded) return
    if (route && route.coordinates && route.coordinates.length > 1) {
      this.mountMapRoute(route)
        .then(() => {
          if (!route.isEditing) {
            this.fitMap(route.coordinates, true)
          }
        })
    } 
    
    else {
      this.clearMapRoute()    
      this.fitMap(undefined, true)
    }
  }
},
   coordinates: {
    deep: true,
    handler() {
      if (!this.isMapLoaded || !this.activeRoute) return
      this.tryDrawActiveRoute()
    }
  }
}

}
</script>

<style lang="scss">
.map-container {
  width: 100%;
  height: 100%;
  background-color: rgba(204, 204, 204, 0.78);

  .map-marker {
    position: absolute;
  }

}
</style>


